import { Control, FieldValues } from 'react-hook-form'

import { FilterFieldRenderer } from './FilterFieldRenderer'
import { FieldBlock } from '../utils/buildFieldBlocks'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@fp/ui-kit'

interface FilterSectionBlockProps<T extends FieldValues> {
  block: FieldBlock<T>
  control: Control<T>
  expandedSections: string[]
  setExpandedSections: (value: string[]) => void
}

export const FilterSectionBlock = <T extends FieldValues>({
  block,
  control,
  expandedSections,
  setExpandedSections,
}: FilterSectionBlockProps<T>) => {
  if (block.section === null) {
    return <FilterFieldRenderer fields={block.fields} control={control} />
  }

  const { section } = block
  const isSectionExpanded = expandedSections.includes(section)

  // Each section renders its own <Accordion>, so we merge toggle into shared state
  const handleAccordionChange = (value: string) => {
    const otherSections = expandedSections.filter((s) => s !== section)
    setExpandedSections(value ? [...otherSections, section] : otherSections)
  }

  return (
    <Accordion type='single' collapsible value={isSectionExpanded ? section : ''} onValueChange={handleAccordionChange}>
      <AccordionItem value={section} variant='card'>
        <AccordionTrigger variant='card'>{section}</AccordionTrigger>
        <AccordionContent variant='card'>
          <FilterFieldRenderer fields={block.fields} control={control} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
